import { useEffect, useRef, useState } from "react";
import { Bell, Receipt, Trash, X } from "@phosphor-icons/react";
import { api } from "../../lib/api";

function timeAgo(iso) {
    try {
        const diff = Date.now() - new Date(iso).getTime();
        const minutes = Math.floor(diff / 60000);
        if (minutes < 1) return "baru saja";
        if (minutes < 60) return `${minutes} menit lalu`;
        const hours = Math.floor(minutes / 60);
        if (hours < 24) return `${hours} jam lalu`;
        return `${Math.floor(hours / 24)} hari lalu`;
    } catch (e) {
        return "";
    }
}

export default function NotificationsBell() {
    const [data, setData] = useState(null);
    const [open, setOpen] = useState(false);
    const panelRef = useRef(null);

    const load = () => {
        api.get("/admin/notifications")
            .then((r) => setData(r.data))
            .catch(() => {});
    };

    useEffect(() => {
        load();
        const timer = setInterval(load, 45000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    const toggle = () => {
        const next = !open;
        setOpen(next);
        if (next) {
            load();
            if (data?.unread > 0) {
                api.post("/admin/notifications/mark-read")
                    .then(() => setData((prev) => (prev ? { ...prev, unread: 0 } : prev)))
                    .catch(() => {});
            }
        }
    };

    const unread = data?.unread || 0;
    const items = data?.items || [];

    return (
        <div className="relative" ref={panelRef}>
            <button
                type="button"
                onClick={toggle}
                data-testid="admin-notifications-bell"
                className="relative p-2 border border-racing-line text-racing-muted hover:text-racing-red hover:border-racing-red transition-colors"
                aria-label="Pemberitahuan"
            >
                <Bell size={18} weight={unread > 0 ? "fill" : "regular"} className={unread > 0 ? "text-racing-red" : ""} />
                {unread > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 bg-racing-red text-white text-[10px] font-medium flex items-center justify-center" data-testid="admin-notifications-badge">
                        {unread > 99 ? "99+" : unread}
                    </span>
                )}
            </button>

            {open && (
                <div className="absolute right-0 top-12 w-[380px] max-w-[90vw] bg-white border border-racing-line shadow-xl z-50" data-testid="admin-notifications-panel">
                    <div className="flex items-center justify-between px-5 py-3.5 border-b border-racing-line bg-racing-surface">
                        <p className="text-[10px] uppercase tracking-[0.25em] text-racing-muted">Pemberitahuan Kwitansi</p>
                        <button type="button" onClick={() => setOpen(false)} className="text-racing-muted hover:text-racing-red" aria-label="Tutup"><X size={16} /></button>
                    </div>
                    <div className="max-h-[420px] overflow-y-auto">
                        {items.length === 0 ? (
                            <p className="px-5 py-8 text-sm text-racing-muted text-center" data-testid="admin-notifications-empty">Belum ada pemberitahuan.</p>
                        ) : (
                            items.map((item, index) => (
                                <div key={item.id} className="flex gap-3 px-5 py-3.5 border-b border-racing-line last:border-0" data-testid={`admin-notification-${index}`}>
                                    <span className={`mt-0.5 w-8 h-8 shrink-0 flex items-center justify-center border ${item.type === "receipt_deleted" ? "border-racing-red/40 text-racing-red bg-red-50" : "border-green-600/40 text-green-700 bg-green-50"}`}>
                                        {item.type === "receipt_deleted" ? <Trash size={15} /> : <Receipt size={15} />}
                                    </span>
                                    <div className="min-w-0">
                                        <p className="text-sm font-medium text-neutral-900">{item.title}</p>
                                        <p className="text-xs text-racing-muted mt-0.5 leading-relaxed">{item.detail}</p>
                                        <p className="text-[10px] uppercase tracking-[0.15em] text-racing-muted mt-1">{timeAgo(item.created_at)}</p>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
